import { Box, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { isEmpty } from 'lodash';
import React, {
  ChangeEvent,
  FC,
  memo,
  useCallback,
  useEffect,
  useState
} from 'react';
import { Category } from 'src/constants/inventory';
import { slices, useAppDispatch, useAppSelector } from 'src/redux';

const {
  actions: categoryActions,
  selectors: categorySelectors
} = slices.category;

interface Props {
  defaultValue?: Category;
  defaultCategoryName?: string;
  onHandleCategories: (categoryId: number) => void;
  clearCategory?: boolean;
}

const component: FC<Props> = ({
  defaultValue,
  onHandleCategories,
  clearCategory
}) => {
  const dispatch = useAppDispatch();
  const categories = useAppSelector(categorySelectors.selectCategories);

  const [selectedCategory, setSelectedCategory] = useState<Category | null>(
    defaultValue || null
  );

  const getCategories = useCallback(
    async (keyword?: string) => {
      try {
        await dispatch(categoryActions.getCategoriesThunk({ keyword }));
      } catch (error) {
        console.error(error);
      }
    },
    [dispatch]
  );

  const onHandleSelectedChangeCategory = (
    event: ChangeEvent<{}>,
    value: Category | null
  ) => {
    setSelectedCategory(value);
    onHandleCategories(value?.id || 0);
  };

  useEffect(() => {
    if (isEmpty(categories)) {
      getCategories('');
    }
  }, [categories, getCategories]);

  useEffect(() => {
    if (defaultValue) {
      setSelectedCategory(defaultValue || null);
    }
  }, [defaultValue]);

  useEffect(() => {
    if (clearCategory) {
      setSelectedCategory(null);
    }
  }, [clearCategory]);

  return (
    <Box>
      <Autocomplete
        id="category-list-dropdown"
        options={categories}
        value={selectedCategory}
        fullWidth
        getOptionLabel={(option) => option.name}
        renderInput={(params) => (
          <TextField {...params} label="Categories" variant="outlined" />
        )}
        onChange={onHandleSelectedChangeCategory}
      />
    </Box>
  );
};

export const CategoryListDropdown = memo(component);
